import { combineReducers } from 'redux'
import viewer from './viewer'
import upload from './upload'

const uiReducer = combineReducers({
  viewer,
  upload
})

export default uiReducer
